import { defineStore } from 'pinia';
import ReportsIndexRepository from "@/Repositories/Reports/ReportsIndexRepository";
import ReportsRepository from "@/Repositories/Reports/ReportsRepository";
import _ from "lodash";
import {EventBus} from "@/event-bus";

export const ReportsStore = defineStore('ReportsStore', {
    state: () => ({
        academicPeriods: [],

        reportTypeName:'',

        statuses: [],

        reports: [],
    }),
    getters:{
        getReportTypeName(){

            return this.reportTypeName;
        }
    },

    actions: {
        setReportTypeName(reportTypeName){
            this.reportTypeName = reportTypeName;
        },

        /**
         *
         * @param academicPeriods
         */
        setAcademicPeriods(academicPeriods) {
            this.academicPeriods = academicPeriods;
        },

        /**
         *
         * @param statuses
         */
        setStatuses(statuses) {
            this.statuses = statuses;
        },

        /**
         * Search data sources matching given criteria
         *
         * @param searchArguments
         * @returns {Promise<*>}
         */
        async searchDataSources(searchArguments) {
            return await ReportsIndexRepository.searchDataSources(searchArguments);
        },

        /**
         * Search report configuration matching given criteria
         *
         * @param searchArguments
         * @returns {Promise<*>}
         */
        async searchReportConfiguration(searchArguments) {
            return await ReportsIndexRepository.searchReportConfiguration(searchArguments);
        },

        /**
         * Store a new Report
         *
         * @param Report
         * @returns {Promise<*>}
         */
        async storeReport(Report, ReportTypeName) {
            const newReport = await ReportsRepository.storeReport(Report,ReportTypeName);

            this.reports = [newReport, ...this.reports];

            EventBus.$emit('reports.stored', _.cloneDeep(newReport))

            return newReport;
        },

        /**
         *
         * @param criteria
         * @returns {Promise<*>}
         */
        async searchReports(criteria) {
            return await ReportsRepository.searchReports(criteria);
        },

        /**
         *
         * @param report
         * @returns {Promise<*>}
         */
        async deleteReport(report) {
            return await ReportsRepository.deleteReport(report);
        },

        /**
         * Updates Report
         *
         * @param Report
         * @returns {Promise<*>}
         */
        async updateReport(Report) {
            return await ReportsRepository.updateReport(Report);
        },
    },
})
